import { Fragment, useState } from 'react';
import { find } from 'ramda';
import styled from 'styled-components';
import Modal from '~~elements/Modal';
import toast from '~~elements/Toast';
import Button from '~~elements/Button';
import { SeasonResource, SeasonRegistryResource } from '~~apis/resource';
import RMultilingual from '../Multilingual';
import { useTournamentState, useTournamentDispatch } from '../../useTournament';
import { useRegistryState } from '../useRegistry';

const StyledDiv = styled.div`
  text-align: center;
  .imported {
    color: red;
  }
`;

const FooterDiv = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  .error {
    color: red;
  }
`;

const ReviewTeamImportModal = ({ team, toClose, setTeams }) => {
  const { registryInfo } = useRegistryState();
  const { tournamentInfo, teams: alreadyImportTeams } = useTournamentState();
  const tournamentDispatch = useTournamentDispatch();

  const [importing, setImporting] = useState(false);

  const handleImport = () => {
    setImporting(true);
    SeasonRegistryResource.importReviewTeamToTournament({
      seasonRegistryUniqid: registryInfo.uniqid,
      reviewTeamUniqid: team.uniqid,
    })
      .then(() => {
        SeasonRegistryResource.getReviewTeams({
          seasonRegistryUniqid: registryInfo.uniqid,
          statusList: ['COMPLETED'],
        }).then(({ data }) => {
          setTeams(data);
          toast(RMultilingual(`SUCCESS.UPDATE`), { status: 'success', second: 1 });
        });
        SeasonResource.getTeams({ seasonUniqid: tournamentInfo.uniqid }).then(({ data }) => {
          tournamentDispatch({ type: 'SET_TEAMS', payload: data });
        });
      })
      .catch((e) => {
        toast(RMultilingual(`COMMON.UNKNOWN_ERROR`), { status: 'error', second: 1 });
      })
      .finally(() => {
        setImporting(false);
      });
  };

  return (
    <Modal.Modal size="lg" isOpen={true} onClickBack={importing ? () => {} : toClose}>
      <Modal.ModalHeader hasBack={!importing} onClickBack={importing ? () => {} : toClose}>
        {`${team.city} ${team.name}`}
      </Modal.ModalHeader>
      <Modal.ModalBody>
        <StyledDiv>
          {team.imported_team && (
            <Fragment>
              <h3 className="imported">{RMultilingual(`REVIEW.IMPORTED_TO_TOURNAMENT`)}</h3>
              <h5 className="imported">{team.imported_team.name}</h5>
              <hr />
            </Fragment>
          )}
          <div className="hint">{RMultilingual(`REVIEW.IMPORT_HINT`)}</div>
          <FooterDiv>
            {team.imported_team ? (
              <i className="error">{RMultilingual(`REVIEW.IMPORTED_COVER_ERROR`)}</i>
            ) : find((t) => t.name === team.name, alreadyImportTeams) ? (
              <i className="error">{RMultilingual(`REVIEW.NAME_DUPLICATE_COVER_ERROR`)}</i>
            ) : (
              <></>
            )}
            <Button width="10rem" color="red" onClick={handleImport}>
              {RMultilingual(
                `REVIEW.${
                  team.imported_team
                    ? 'IMPORTED_COVER'
                    : find((t) => t.name === team.name, alreadyImportTeams)
                    ? 'NAME_DUPLICATE_COVER'
                    : 'IMPORT_NOW'
                }`,
              )}
            </Button>
          </FooterDiv>
        </StyledDiv>
      </Modal.ModalBody>
    </Modal.Modal>
  );
};

export default ReviewTeamImportModal;
